/* eslint-disable no-useless-escape */
const specialCharactersPattern = /^[^<>\/'"&;:{}[\]()*]+$/
// 必填資料1
const requireRegisterDataFirst = [
  {
    type: "input",
    title: "手機號碼",
    placeholder: "為您的帳號，共 10 碼",
    formData: {
      name: "mobile",
      rules: [
        { required: true, message: "手機號碼為必填" },
        {
          len: 10,
          message: "手機號碼格式錯誤",
        },
      ],
    },
  },
  {
    type: "shadow",
    title: "密碼",
    placeholder: "6 - 12 碼英數字 ",
    formData: {
      name: "password",
      rules: [
        { required: true, message: "手機號碼為必填" },
        {
          min: 6,
          message: "密碼須為 6-12 碼英數字混合",
        },
        {
          max: 12,
          message: "密碼須為 6-12 碼英數字混合",
        },
        // {
        //   pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
        //   message: "密碼須為 6-12 英數字混合",
        // },
      ],
    },
  },
  {
    type: "shadow",
    title: "密碼確認",
    placeholder: "6 - 12 碼英數字 ",
    formData: {
      name: "confirm",
      rules: [
        {
          required: true,
          message: "請再輸入一次密碼!",
        },
        // ({ getFieldValue }) => ({
        //   validator(_, value) {
        //     if (!value || getFieldValue("password") === value) {
        //       return Promise.resolve();
        //     }
        //     return Promise.reject(new Error("密碼輸入不一致!"));
        //   },
        // }),
      ],
    },
  },
];

//必填資料2
const requireRegisterDataSecond = [
  {
    type: "input",
    title: "姓名",
    placeholder: "請輸入您的姓名",
    formData: {
      name: "name",
      rules: [
        { 
          required: true, 
          message: "姓名為必選" 
        },
        {
          pattern: specialCharactersPattern,
          message: '姓名不能有特殊符號'
        }
      ],
    },
  },
  {
    type: "select",
    title: "性別",
    placeholder: "",
    options: [
      { value: "M", optionName: "男性" },
      { value: "F", optionName: "女性" },
    ],
    formData: {
      name: "sex",
      rules: [{ required: true, message: "性別為必選" }],
    },
  },
  {
    type: "date",
    title: "生日",
    placeholder: "",
    formData: {
      name: "birth",
      rules: [{ required: true, message: "出生日期為必填" }],
    },
  }
];

//必填資料3

const requireRegisterDataThird = [
  {
    type: "recommend",
    title: "推薦門市",
    placeholder: "",
    options: [],
    formData: {
      name: "recommendStore",
      rules: [
        { required: true, message: "推薦門市為必填" }
      ],
    },
  },
  {
    type: "input",
    title: "電子信箱",
    placeholder: "請輸入您的電子信箱",
    formData: {
      name: "email",
      rules: [
        {
          pattern: "^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,64}$",
          message: "格式錯誤",
        },
      ],
    },
  }
]


// //選填資料1
// const optionalRegisterDataFirst = [
//   {
//     type: "select",
//     title: "通訊地址",
//     placeholder: "",
//     options: [{ value: "001", optionName: "樹林" }],
//   },
//   { type: "input", title: "", placeholder: "請填寫完整住址" },
// ];

//選填資料1並取得地區陣列
function getOptionRegisterDataFirst(region) {
  return [
    {
      type: "selectRegion",
      title: "通訊地址-縣市",
      placeholder: "",
      options: region,
      formData: {
        name: "city",
        rules: [],
      },
    },
    // {
    //   type: "selectRegion",
    //   title: "通訊地址-地區",
    //   placeholder: "",
    //   options: region,
    //   formData: {
    //     name: "name",
    //     rules: [],
    //   },
    // },
    {
      type: "input",
      title: "",
      placeholder: "請填寫完整住址",
      formData: {
        name: "address",
        rules: [
          {
            pattern: specialCharactersPattern,
            message: '住址不能有特殊符號'
          }
        ],
      },
    },
  ];
}

//選填資料2
const optionalRegisterDataSecond = [
  {
    type: "input",
    title: "連絡電話",
    placeholder: "請填寫區碼",
    formData: {
      name: "areaCode",
      rules: [{ pattern: "^[0-9]*$", message: "不可輸入數字以外的文字" }],
    },
  },
  {
    type: "input",
    title: "",
    placeholder: "請填寫電話號碼",
    formData: {
      name: "phone",
      rules: [{ pattern: "^[0-9]*$", message: "不可輸入數字以外的文字" }],
    },
  },
  {
    type: "input",
    title: "",
    placeholder: "請填寫分機號碼",
    formData: {
      name: "extensionNumber",
      rules: [{ pattern: "^[0-9]*$", message: "不可輸入數字以外的文字" }],
    },
  },
];

//選填資料3
const optionalRegisterDataThird = [
  {
    type: "select",
    title: "學歷",
    placeholder: "",
    options: [
      { value: "1", optionName: "高中" },
      { value: "2", optionName: "大專" },
      { value: "3", optionName: "研究所(以上)" },
      { value: "4", optionName: "其他" },
    ],
    formData: {
      name: "education",
      rules: [],
    },
  },
  {
    type: "select",
    title: "行業別",
    placeholder: "",
    options: [
      { value: "1", optionName: "軍公教" },
      { value: "2", optionName: "金融保險業" },
      { value: "3", optionName: "電子資訊業" },
      { value: "4", optionName: "醫療保健業" },
      { value: "5", optionName: "製造業" },
      { value: "6", optionName: "批發貿易業" },
      { value: "7", optionName: "零售業" },
      { value: "8", optionName: "餐飲業" },
      { value: "9", optionName: "廣告出版業" },
      { value: "10", optionName: "休閒娛樂業" },
      { value: "11", optionName: "自由業" },
      { value: "12", optionName: "家管" },
      { value: "13", optionName: "其他" },
    ],
    formData: {
      name: "profession",
      rules: [],
    },
  },
  {
    type: "select",
    title: "如何得知申辦",
    placeholder: "",
    options: [
      { value: "01", optionName: "食品管門市" },
      { value: "02", optionName: "百貨專櫃" },
      { value: "03", optionName: "國道服務區" },
      { value: "04", optionName: "機場" },
      { value: "05", optionName: "客運轉運站" },
      { value: "06", optionName: "購物網" },
      { value: "07", optionName: "親友推薦" },
      { value: "08", optionName: "廣告宣傳" },
      { value: "09", optionName: "其他" },
    ],
    formData: {
      name: "applicationWay",
      rules: [],
    },
  },
];

//選填資料 checkbox -優惠訊息接受方式
const optionalRegisterCheckboxFirst = {
  title: "優惠訊息接收方式(可複選)",
  formData: {
    name: "getDiscountWay",
    rules: [],
  },
  items: [
    { label: "郵寄", value: "M" },
    { label: "簡訊", value: "S" },
    { label: "電郵", value: "E" },
  ],
};

//選填資料 checkbox -感興趣的活動
const optionalRegisterCheckboxSecond = {
  title: "感興趣的活動(可複選)",
  formData: {
    name: "interestActivity",
    rules: [],
  },
  items: [
    { label: "座談演講", value: "A" },
    { label: "展覽", value: "B" },
    { label: "手作體驗", value: "C" },
    { label: "市集活動", value: "D" },
    { label: "音樂會", value: "E" },
    { label: "電影欣賞", value: "F" },
    { label: "品酒會", value: "G" },
    { label: "美食烹調", value: "H" },
    { label: "運動賽事", value: "I" },
  ],
};
export {
  requireRegisterDataFirst,
  requireRegisterDataSecond,
  requireRegisterDataThird,
  //   optionalRegisterDataFirst,
  optionalRegisterDataSecond,
  optionalRegisterDataThird,
  optionalRegisterCheckboxFirst,
  optionalRegisterCheckboxSecond,
  getOptionRegisterDataFirst,
};
